export const SUBSCRIPTIONS_CHANGED_EVENT = 'orizonte-subscriptions-changed';
